<template>
	<router-view/>
</template>

<script>
	import { mapState, mapActions } from 'vuex';
	import { client } from '@/api/client';

	export default {
		computed: {
			...mapState(['pageTitle', 'progressStatus']),

			title() {
				return `${this.pageTitle} - Mobile Counter Stockist`;
			},
		},
		watch: {
			pageTitle(val, oldVal) {
				if (val !== oldVal) {
					document.title = this.title;
				}
			},

			progressStatus(val, oldVal) {
				if (val !== oldVal) {
					switch (val) {
						case 'start':
						this.$Progress.start();
						break;
						case 'fail':
						this.$Progress.fail();
						break;
						default:
						this.$Progress.finish();
						break;
					}
				}
			},
		},
		methods: {
			...mapActions('auth', ['logout']),

			forceLogout() {
				this.logout().then(() => {
					this.$router.push({ name: 'login' });
				});
			},
		},
		created: function () {
			client.interceptors.response.use(undefined, (error) => {
				return new Promise(() => {
					if (error.response.status  == 406) {
						this.forceLogout()
					}
					throw error
				})
			});
		}
	};
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap";
@import "./styles/variables";
@import "./styles/style";
@import "./styles/responsive";
</style>